import MUIAutocomplete from '@mui/material/Autocomplete';

export const Autocomplete = MUIAutocomplete;
